import React from 'react';
import FloorPlanCanvas from './FloorPlanCanvas';
import type { FloorPlan } from '../types';

interface FloorPlanViewerProps {
  floorPlan: FloorPlan;
  highlightedTableNumber?: number;
  guestName?: string;
  className?: string;
}

export default function FloorPlanViewer({ 
  floorPlan, 
  highlightedTableNumber, 
  guestName,
  className = '' 
}: FloorPlanViewerProps) {
  if (!floorPlan) {
    return (
      <div className={`floor-plan-viewer ${className}`}>
        <div className="card">
          <p>No floor plan available</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`floor-plan-viewer ${className}`}>
      <div className="card">
        <div style={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center', 
          marginBottom: '1rem' 
        }}>
          <h3>Venue Floor Plan</h3>
          {highlightedTableNumber && (
            <div style={{
              background: '#fff3cd',
              color: '#856404',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '14px',
              fontWeight: '600'
            }}>
              Table {highlightedTableNumber}
            </div>
          )}
        </div>
        
        <div style={{ 
          height: '400px', 
          border: '1px solid #dee2e6', 
          borderRadius: '8px', 
          overflow: 'hidden',
          position: 'relative',
          background: '#f8f9fa'
        }}>
          <FloorPlanCanvas
            floorPlan={floorPlan}
            onTableUpdate={() => {}} // Read-only
            onTableSelect={() => {}} // Read-only
            highlightedTableNumber={highlightedTableNumber}
            isEditable={false}
          />
        </div>
        
        {highlightedTableNumber && (
          <div className="floor-plan-viewer-note">
            <div className="floor-plan-viewer-note__headline">
              {guestName ? `Welcome ${guestName}, your are assigned to table number ${highlightedTableNumber}.` : `Your are assigned to table number ${highlightedTableNumber}.`}
            </div>
            <div className="floor-plan-viewer-note__copy">
              The venue plan above highlights your table in yellow.
            </div>
          </div>
        )}

      </div>
    </div>
  );
}
